module.exports = __webpack_public_path__ + "static/media/click_feedback.538c94d1.flac";